// Project switcher placeholder — wired to a hardcoded fixture for now.
// Phase 2/3 will connect this to /api/projects with the actual user's grants.
import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export type ProjectSummary = {
  id: string;
  name: string;
  color: string;
  icon: string;
};

const FIXTURES: ProjectSummary[] = [
  { id: "all", name: "All projects", color: "#64748B", icon: "🌍" },
  { id: "jobgoblin", name: "Job Goblin Core", color: "#084F57", icon: "🧌" },
];

export function ProjectSwitcher() {
  const [current, setCurrent] = useState<ProjectSummary>(FIXTURES[0]!);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2">
          <span aria-hidden>{current.icon}</span>
          <span className="font-medium">{current.name}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[14rem]">
        <DropdownMenuLabel>Switch project</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {FIXTURES.map((p) => (
          <DropdownMenuItem
            key={p.id}
            onClick={() => setCurrent(p)}
            className="gap-2"
          >
            <span aria-hidden>{p.icon}</span>
            <span>{p.name}</span>
            {p.id === current.id && <Check className="ml-auto h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
